import { forEach, has, isArray } from "lodash";

function addErrorClass(errors) {
  forEach(errors, (error) => {
    if (isArray(error) || !has(error, "ref")) {
      addErrorClass(error);
    } else {
      error?.ref?.classList?.add("field-error");
      toastr.error(error?.message || I18n.t("generic_error"));
    }
  });
}

export function onValidationError(errors) {
  resetValidationErrors();
  console.log("GOT ERRORS OR NOT?", errors);
  addErrorClass(errors);
}

export function resetValidationErrors() {
  forEach(document.getElementsByClassName("field-error"), (element) => {
    element?.classList.remove("field-error");
  });
}
